/**
 * Ryan O'Dowd
 * 2024-10-30
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Text from './Text';
import Wrapper from './Wrapper';

const EmptyScreen = {
  Text,
  Wrapper,
};

export default EmptyScreen;
